import { BigDecimal } from "@solomon-labs/bigdecimal";

/** Retail display defaults when YaaS values are unavailable. */
export const DEFAULT_RETAIL_DISTRIBUTION_DAYS = 14;
export const DEFAULT_RETAIL_MIN_BALANCE_USDV = 10;
export const DEFAULT_RETAIL_MIN_YIELD_PER_DISTRIBUTION_USDV = 5;

/** The live minimum USDv a wallet must hold to earn, or the default while YaaS has not sent one. */
export function retailMinBalance(minBalance: string | null): BigDecimal {
    return new BigDecimal(minBalance ?? String(DEFAULT_RETAIL_MIN_BALANCE_USDV));
}
